export function StatusDot({ status }: { status: "active" | "paused" | "error" | string }) {
  const cls = status === "active" ? "green" : status === "error" ? "red" : "amber";
  return <span className={`dot ${cls}`} title={status} />;
}
